import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Flex, Text} from '@chakra-ui/react3'

export const ProductData = ({title, data, variant, asHTML, ...props}) => {
    const {formatMessage} = useIntl()
    const dataMessages = {
        width: formatMessage({
            defaultMessage: 'W',
            id: 'specifications.product_data.width'
        }),
        height: formatMessage({
            defaultMessage: 'H',
            id: 'specifications.product_data.height'
        }),
        depth: formatMessage({
            defaultMessage: 'D',
            id: 'specifications.product_data.depth'
        }),
        unitOfMeasurement: formatMessage({
            defaultMessage: 'cm',
            id: 'specifications.product_data.unitOfMeasurement'
        }),
        inch: formatMessage({
            id: 'specifications.product_data.inch',
            defaultMessage: 'in'
        }),
        kg: formatMessage({
            defaultMessage: 'kg',
            id: 'specifications.product_data.kg'
        }),
        lbs: formatMessage({
            defaultMessage: 'lbs',
            id: 'specifications.product_data.lbs'
        }),
        years: formatMessage({
            defaultMessage: 'years',
            id: 'specifications.product_data.years'
        })
    }

    const getSuitsAge = () => {
        return data.to
            ? data.from || data.from === 0
                ? formatMessage(
                      {
                          defaultMessage: 'From {0} To {1} months',
                          id: 'pdp.module.specifications.from-to-months'
                      },
                      {
                          0: data.from,
                          1: data.to
                      }
                  )
                : formatMessage(
                      {
                          defaultMessage: 'To {0} months',
                          id: 'pdp.module.specifications.to-months'
                      },
                      {
                          0: data.to
                      }
                  )
            : data.from || data.from === 0
            ? formatMessage(
                  {
                      defaultMessage: 'From {0} months',
                      id: 'pdp.module.specifications.from-months'
                  },
                  {
                      0: data.from
                  }
              )
            : ''
    }

    return (
        <Flex direction="column" gap={1} {...props}>
            <Text as="h3" textStyle="body.small" color="text.tertiary">
                {title}
            </Text>

            {!variant && asHTML && data.text ? (
                <Text
                    textStyle="body.default"
                    color="text.primary"
                    dangerouslySetInnerHTML={{__html: data.text}}
                />
            ) : (
                <Text textStyle="body.default" color="text.primary">
                    <span>
                        {variant === 'dimensions' &&
                            `${dataMessages.width} ${data.width} ${dataMessages.unitOfMeasurement} x
                ${dataMessages.height} ${data.height} ${dataMessages.unitOfMeasurement} x
                ${dataMessages.depth} ${data.length} ${dataMessages.unitOfMeasurement} /
                ${dataMessages.width} ${data.widthInch} ${dataMessages.inch} x
                ${dataMessages.height} ${data.heightInch} ${dataMessages.inch} x
                ${dataMessages.depth} ${data.lengthInch} ${dataMessages.inch}`}
                    </span>

                    <span>
                        {(variant === 'netWeight' || variant === 'suitsWeight') &&
                            `${data.kg}  ${dataMessages.kg} / ${data.lbs}  ${dataMessages.lbs}`}
                    </span>

                    <span>{variant === 'suitsAge' && getSuitsAge()}</span>

                    <span>
                        {variant === 'extendedWarranty' && `${data.text} (${dataMessages.years})`}
                    </span>

                    <span>
                        {(variant === 'material' || variant === 'designers') &&
                            data.array.join(', ')}
                    </span>

                    <span>{!variant && data.text}</span>
                </Text>
            )}
        </Flex>
    )
}

ProductData.propTypes = {
    title: PropTypes.string,
    data: PropTypes.any,
    variant: PropTypes.string,
    // Indicates if the data should be dangerously rendered as HTML
    asHTML: PropTypes.bool
}

export default ProductData
